<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-primary">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'stops.listing' }"
          >Stops</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-bold my-6 text-capitalize">
        Create Stop
      </div>

      <!-- Stop Form -->
      <div class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
        <v-form ref="form" v-if="form" class="place-form">
          <h3 class="py-5 primary--text">Stop Information</h3>

          <label class="text-field-label">Name</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.name"
            :error-messages="form.$getError('name')"
            :loading="loading"
          ></v-text-field>

          <label class="text-field-label">Location</label>
          <PlaceAutocomplete
            v-model="form.places_address"
            @select="form.google_places_id = $event"
            :inputError="form.$getError('google_places_id')"
          />

          <label class="text-field-label">Landmarks</label>
          <v-autocomplete
            class="mt-2"
            v-model="form.place_ids"
            :items="landmarks"
            :loading="fetchingLandmarks"
            filled
            multiple
            item-text="name"
            item-value="id"
            :error-messages="form.$getError('place_ids')"
          >
            <template v-slot:append-outer>
              <v-btn
                color="normal"
                @click="getLandmarks()"
                :loading="fetchingLandmarks"
                icon
              >
                <v-icon>
                  {{ icons.refresh }}
                </v-icon>
              </v-btn>
            </template>
          </v-autocomplete>

          <label class="text-field-label">Shops</label>
          <v-autocomplete
            class="mt-2"
            v-model="form.place_ids"
            :loading="fetchingStores"
            :items="stores"
            filled
            multiple
            item-text="name"
            item-value="id"
            :error-messages="form.$getError('place_ids')"
          >
            <template v-slot:append-outer>
              <v-btn
                color="normal"
                @click="getStores()"
                :loading="fetchingStores"
                icon
              >
                <v-icon>
                  {{ icons.refresh }}
                </v-icon>
              </v-btn>
            </template>
          </v-autocomplete>

          <label class="text-field-label">Restaurants</label>
          <v-autocomplete
            class="mt-2"
            v-model="form.place_ids"
            :loading="fetchingRestaurants"
            :items="restaurants"
            filled
            multiple
            item-text="name"
            item-value="id"
            :error-messages="form.$getError('place_ids')"
          >
            <template v-slot:append-outer>
              <v-btn
                color="normal"
                @click="getRestaurants()"
                :loading="fetchingRestaurants"
                icon
              >
                <v-icon>
                  {{ icons.refresh }}
                </v-icon>
              </v-btn>
            </template>
          </v-autocomplete>

          <div class="mt-10 d-flex">
            <v-btn
              color="normal"
              class="mr-5 px-6"
              height="40px"
              width="47%"
              :loading="form.$busy"
              :to="{ name: 'stops' }"
              >Back</v-btn
            >
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              class="px-6"
              height="40px"
              width="47%"
              :loading="form.$busy"
              @click="saveStopDetails"
              >Save</v-btn
            >
          </div>
        </v-form>
      </div>
      <!-- End of Stop Form -->
    </div>
  </div>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import PlaceAutocomplete from '@/components/PlaceAutocomplete'

import Form from '@/utils/form'
import { mapActions } from 'vuex'
import StopForm from '@/utils/mixins/StopForm'

export default {
  name: 'CreateStop',

  mixins: [ControlsMixin, StopForm],

  components: {
    AppBarNavIcon,
    PlaceAutocomplete
  },

  data() {
    return {
      loading: false,
      form: null
    }
  },

  async created() {
    this.clearStopDetails()

    await Promise.all([
      this.getLandmarks(),
      this.getStores(),
      this.getRestaurants()
    ])

    this.form = new Form(this.stop)
    this.loading = false
  },

  methods: {
    ...mapActions({
      createStop: 'stop/createStop',
      clearStopDetails: 'stop/clearStopDetails',
      setAlert: 'alert/setAlert'
    }),

    async saveStopDetails() {
      this.form.$busy = true
      this.form.$clearErrors()

      this.createStop(this.form)
        .then(() => {
          this.form.$busy = false
          this.setAlert({
            message: 'Stop details successfully saved!',
            color: 'success'
          })
          this.$router.replace({ name: 'stops.listing' })
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    }
  }
}
</script>
